/**
 * @description Does nothing calls and empty function
 */
export const noop = (): void => undefined
